import { deepChange } from "../../actions";

export const plotRoute = (c1, c2) => {
  window.geoIframe?.postMessage({ command: "plot-route", c1, c2 }, "*");
};

export const setView = (startPos) => {
  window.geoIframe?.postMessage({ command: "set-view", startPos }, "*");
};

export const switchCategory = (newCat) => (dispatch) => {
  dispatch(deepChange({ "guide.selectedCategory": newCat }));
};
